var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.important_message)?_c('section',{ref:"importnant-message-bar",staticClass:"important-message-bar"},[_c('p',{attrs:{"data-cy":"important-message"}},[_vm._v(_vm._s(_vm.important_message))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }